// extracted by mini-css-extract-plugin
export var searchHeader = "_3u-0";
export var searchHeaderDark = "_3u-1";